import React from 'react';
import ACD from '../../assets/ACD.png';
import './styles/collaborators.css';

const COLLABORATORS = [
  {
    href: 'https://www.instagram.com/acd_malaga/',
    img: ACD,
    alt: 'ACD Málaga - Colaborador Oficial',
    name: 'ACD Málaga',
  },
];

const CollaboratorsSection = ({
  className = '',
  title = 'Colaborador Oficial',
  titleClassName = 'collaborators-section-label',
  titleTag = 'span',
}) => {
  const rootClassName = ['collaborators-section', className].filter(Boolean).join(' ');
  const TitleTag = titleTag;

  return (
    <div className={rootClassName}>
      <TitleTag className={titleClassName}>{title}</TitleTag>
      <div className="collaborators-grid">
        {COLLABORATORS.map((collaborator) => (
          <a
            key={collaborator.name}
            href={collaborator.href}
            target="_blank"
            rel="noopener noreferrer"
            className="collaborators-card"
          >
            <span className="collaborators-logo-frame">
              <img src={collaborator.img} alt={collaborator.alt} className="collaborators-logo" />
            </span>
            <span className="collaborators-name">{collaborator.name}</span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default CollaboratorsSection;